import { render, staticRenderFns } from "./StatsOverview.vue?vue&type=template&id=72197fd6&scoped=true&"
import script from "./StatsOverview.vue?vue&type=script&lang=js&"
export * from "./StatsOverview.vue?vue&type=script&lang=js&"
import style0 from "./StatsOverview.vue?vue&type=style&index=0&id=72197fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72197fd6",
  null
  
)

export default component.exports